import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Form, Row } from 'antd';
import { momentizeObjectDates } from '@core/utils/methods';
import { YES_NO_GROUP } from '@models/constants';
import { EditableInformationProps } from '@models/interfaces';
import { Panel, RADTable } from '@shared/components';
import {
  Autocomplete,
  DatePicker,
  Input,
  InputNumber,
  RadioGroup,
} from '@shared/modules';
import { DDVSelectors } from '@store/selectors';

export const ScopingInformation: FC<EditableInformationProps> = ({
  className,
  isEditing,
  form,
  expectedId,
  data,
  onValuesChange,
}: PropsWithChildren<EditableInformationProps>) => {
  const dropdownsOptions = useSelector(DDVSelectors.getDDVOptions);

  useEffect(() => {
    if (data) {
      form?.setFieldsValue({
        ...momentizeObjectDates(data, ['prelimRFDSReceived']),
      });
    }
  }, []);

  return (
    <Panel header="Scoping Information" className={className} collapsible>
      <Form
        labelCol={{ span: 14 }}
        wrapperCol={{ span: 10 }}
        form={form}
        onValuesChange={onValuesChange}
      >
        <Row>
          <Col span="12">
            <Row>
              <Col span="12">
                <DatePicker
                  id="prelimRFDSReceived"
                  label="Prelim RFDS Received"
                  isEditing={isEditing}
                />
                <RadioGroup
                  id="microwaveToBeRemoved"
                  label="Microwave to Be Removed"
                  buttons={YES_NO_GROUP}
                  isEditing={isEditing}
                />
                <RadioGroup
                  id="craneRequired"
                  label="Crane Required"
                  buttons={YES_NO_GROUP}
                  isEditing={isEditing}
                />
                <InputNumber
                  id="craneHeight"
                  label="Crane Height"
                  isEditing={isEditing}
                />
                <Autocomplete
                  id="mountModelReplacement"
                  label="Mount Model Replacement"
                  isEditing={isEditing}
                  options={dropdownsOptions?.MountModelReplacement}
                />
              </Col>
              <Col span="12">
                <Input id="azimuthA" label="Azimuth A" isEditing={false} />
                <Input id="azimuthB" label="Azimuth B" isEditing={false} />
                <Input id="azimuthG" label="Azimuth G" isEditing={false} />
                <Input id="azimuthD" label="Azimuth D" isEditing={false} />
              </Col>
            </Row>
          </Col>
          <Col span="11">
            <RADTable projectId={expectedId!} isEditing={isEditing} />
          </Col>
        </Row>
      </Form>
    </Panel>
  );
};
